import { Container, Typography } from '@design-system';
import { DEFAULT_IMAGE } from '@utils';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './GenericCategoryDisplayer.scss';
import { GenericCategorySkeleton } from './GenericCategorySkeleton';
import { useGenericCategoryDisplayer } from './useGenericCategoryDisplayer';

type GenericCategoryDisplayerProps = {
    type: 'appro' | 'epi';
    basePath: string;
};

export const GenericCategoryDisplayer: React.FC<GenericCategoryDisplayerProps> = ({ type, basePath }) => {
    const { categories, isLoading, errorMessage, toTitleCase } = useGenericCategoryDisplayer(type);
    const navigate = useNavigate();

    if (errorMessage) {
        return (
            <Container>
                <Typography intrinsic="p" color="red">
                    {errorMessage}
                </Typography>
            </Container>
        );
    }

    const handleCategoryClick = (categoryId: string) => {
        navigate(`${basePath}/category/${categoryId}`);
    };

    return (
        <Container className="generic-category-displayer" padding="none" row>
            {isLoading ? (
                <GenericCategorySkeleton />
            ) : (
                categories.map((category) => (
                    <Container
                        key={category.id}
                        className="category-card"
                        bordered="grey"
                        padding="none"
                        onClick={() => handleCategoryClick(category.id)}
                    >
                        <img src={category.image ?? DEFAULT_IMAGE} alt={category.label} className="category-image" />
                        <Typography intrinsic="h4" color="marine" className="category-label" defaultSpacing={false}>
                            {toTitleCase(category.label)}
                        </Typography>
                    </Container>
                ))
            )}
        </Container>
    );
};
